"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = require("../../../parts/Tooltip");
exports.default = Tooltip_1.Tooltip;
//# sourceMappingURL=Tooltip.js.map